import { type ReactNode } from 'react'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  children: ReactNode
  className?: string
}

export const StepTitle = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        'text-2xl font-semibold leading-9',
        'lg:text-[32px] lg:leading-[42px]',
        className
      )}>
      {children}
    </div>
  )
}
